module.exports = __webpack_public_path__ + "img/MDC_Standard_gross.436775a6.png";